import { render } from "./ReportFornitura.vue?vue&type=template&id=c6dc21f2&scoped=true"
import script from "./ReportFornitura.vue?vue&type=script&lang=js"
export * from "./ReportFornitura.vue?vue&type=script&lang=js"

import "./ReportFornitura.vue?vue&type=style&index=0&id=c6dc21f2&lang=css"
import "./ReportFornitura.vue?vue&type=style&index=1&id=c6dc21f2&scoped=true&lang=css"

import exportComponent from "C:\\Users\\ma-dg\\Desktop\\wa\\ask_wizard\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c6dc21f2"]])

export default __exports__